import gql from "graphql-tag"

const masSearchItem = gql`
  fragment MASSearchItem on MASSearchItem {
    id
    title
    year
  }
`

export default masSearchItem
